export const analyticsDashboardData = state => state.dashboardData;
export const studyIdValue = state => state.studyId;
export const sitesData = state => state.sitesData;
export const benchMarkData = state => state.benchMarkData;
export const enrollmentParticipantData = state => state.enrollmentData;
export const eConsentUploadedData = state => state.eConsentUploadedData;
export const topScreenFailuaresReason = state => state.topScreenFailuaresReason;
export const quizData = state => state.quizData;
export const recruitmentData = state => state.recruitmentData;
export const sensorComplianceData = state => state.sensorComplianceData;
export const overallCollectionData = state => state.overallCollectionData;
export const cacelledTelehealthVisits = state => state.cacelledTelehealthVisits;
export const complianceInsightScoreData = state => state.complianceInsightScore;
export const overallCollectionMissingData = state => state.overallCollectionMissingData;
export const nonCompliantActivities = state => state.nonCompliantActivities;
export const telehealthVisitsDuration = state => state.telehealthVisitsDuration;
export const complianceRateOverTime = state => state.complianceRateOverTime;
export const studyComplianceData = state => state.studyComplianceData;
export const studyParticipantComplianceData = state => state.studyParticipantComplianceData;
export const overallCollectionParticipantData = state => state.overallCollectionParticipantData;
export const graphicComplianceData = state => state.graphicComplianceData;
export const analyticsUsersData = state => state.analyticsUsersData;
export const dashboardRefreshData = state => state.dashboardRefreshData;
export const siteById = state => state.siteById;
export const allEnrollmentData = state => state.allEnrollmentData;
export const participantProgressData = state => state.participantProgressData;
export const discontinuationActivity = state => state.discontinuationActivity;
export const otherDiscontinuationReasons = state => state.otherDiscontinuationReasons;
export const participantStudyProgression = state => state.participantStudyProgression;
export const milestonesData = state => state.milestonesData;
export const selectedSiteId = state => state.selectedSiteId;
export const queriesList = state => state.queriesData;
export const queriesTimeList = state => state.queriesTimeList;
export const activitiesData = state => state.activitiesData;
export const formStatusData = state => state.formStatusData;
export const totalQueryData = state => state.totalQueryData;
export const totalDataChangeData = state => state.totalDataChangeData;
